import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const postDetailsService = {
  getpostDetails: async () => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/postDetails`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    const data = await response.json();
    return data.types;
  },

  updatepostDetails: async (id, updatedField) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/postDetails/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(updatedField),
    });
    const data = await response.json();
    return data;
  },

  deletepostDetails: async (id) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    await fetch(`${API_URL}/postDetails/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
  },

  addpostDetails: async (newField) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/postDetails`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(newField),
    });
    const data = await response.json();
    return data;
  },
};

export default postDetailsService;
